import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Typography,
} from "@suraasa/placebo-ui"
import clsx from "clsx"
import { ViewGrid } from "iconoir-react"
import { motion } from "motion/react"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { trackingService } from "utils/tracking"
import { TrackingEvents } from "utils/tracking/events"

import { EXPLORE_MENU_OPENED_EVENT_NAME } from "../Link"

type MoreLink = {
  key?: string
  name: string
  link: string
  icon?: any
}

const ExploreMenu = ({
  moreLinks,
  iconOnly = false,
}: {
  moreLinks: MoreLink[]
  iconOnly?: boolean
}) => {
  const [isMoreTabActive, setMoreTabActive] = useState(false)

  useEffect(() => {
    const event = new Event(EXPLORE_MENU_OPENED_EVENT_NAME)
    window.dispatchEvent(event)
  }, [isMoreTabActive])

  return (
    <DropdownMenu open={isMoreTabActive} onOpenChange={setMoreTabActive}>
      <DropdownMenuTrigger>
        <Typography
          variant="button"
          className={clsx(
            "flex h-3.5 items-center justify-center gap-0.5 rounded-xl px-1 py-0.5 text-onSurface-500 hover:outline hover:outline-primary-100",
            {
              "!bg-primary-50 text-primary-600": isMoreTabActive,
              "rounded-lg": iconOnly,
            }
          )}
        >
          {iconOnly ? (
            <ViewGrid className="!size-2.25" />
          ) : (
            <>
              <motion.span
                className="mt-0.5"
                initial={{ x: -10, opacity: 0 }}
                animate={{
                  x: isMoreTabActive ? 0 : 10,
                  opacity: isMoreTabActive ? 1 : 0,
                }}
                transition={{ duration: 0.3, ease: "easeOut" }}
              >
                {isMoreTabActive && <ViewGrid className="mb-0.5 !size-2.25" />}
              </motion.span>
              Explore
            </>
          )}
        </Typography>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuGroup>
          {moreLinks.map(route => (
            <Link to={route.link} key={route.name}>
              <DropdownMenuItem
                onClick={() => {
                  trackingService.trackEvent(
                    TrackingEvents.navMoreLinkClicked,
                    {
                      name: route.name,
                    }
                  )
                }}
                startAdornment={route.icon ? <route.icon /> : null}
              >
                <Typography>{route.name}</Typography>
              </DropdownMenuItem>
            </Link>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ExploreMenu
